// Projects and Drawings (OQ-162). Words from domain/CONTEXT.md § Swedish UI terms.
export const svProjects = {
  context: {
    loadFailed: 'Kunde inte ladda projekten.',
    deleted: 'Projektet har tagits bort',
    deleteFailed: 'Kunde inte ta bort projektet.',
    deleteProject: 'Ta bort projektet',
    permanentWarning: 'Åtgärden är <b>permanent</b> och tar bort all data',
    deleteTitle: 'Ta bort projektet?'
  },
  list: {
    title: 'Projekt',
    addProject: 'Lägg till projekt',
    importCsv: 'Importera CSV',
    exportCsv: 'Exportera CSV',
    columnName: 'Projektnamn',
    columnOrganisation: 'Organisation',
    columnStatus: 'Status',
    empty: 'Det finns inga projekt än.',
    unableToAdd: 'Kunde inte lägga till {{name}}.',
    csvBadFormat: 'CSV-filen har fel format.',
    importSuccessful: 'Importen lyckades',
    importFailed: 'Kunde inte importera CSV-filen.',
    importPartial_one: 'Importen lyckades delvis, men rad {{lines}} kunde inte importeras.',
    importPartial_other: 'Importen lyckades delvis, men raderna {{lines}} kunde inte importeras.',
    linkFailed: 'Kunde inte skapa kameralänken.',
    linkTryLater: 'Något gick fel. Försök igen senare.',
    saveLinkFailed: 'Kunde inte spara den nya länken på projektet.'
  },
  create: {
    insertName: 'Ange ett projektnamn',
    selectOrganisation: 'Välj en organisation',
    created: 'Projektet {{name}} har lagts till',
    createFailed: 'Kunde inte lägga till projektet.',
    title: 'Lägg till projekt',
    projectName: 'Projektnamn',
    organisation: 'Organisation',
    status: 'Status',
    createProject: 'Lägg till projekt'
  },
  view: {
    wrongId: 'Fel projekt-id',
    notFound: 'Projektet finns inte.',
    badData: 'Något är fel med projektets data.',
    updated: 'Projektet {{name}} har sparats',
    updateFailed: 'Kunde inte spara projektet.',
    projectName: 'Projektnamn',
    nameMissing: 'Ange ett projektnamn',
    organisation: 'Organisation',
    status: 'Status',
    update: 'Spara',
    edit: 'Redigera',
    editTitle: 'Redigera projektet',
    cameraLink: 'Kameralänk och QR',
    statusLine: 'Status: {{status}}',
    noStatus: 'Ingen status',
    mediaCount_one: '{{count}} ärende',
    mediaCount_other: '{{count}} ärenden',
    drawingCount_one: '{{count}} ritning',
    drawingCount_other: '{{count}} ritningar',
    mediaTitle: 'Ärenden i projektet',
    drawingsTitle: 'Ritningar',
    noMedia: 'Inga ärenden i projektet.',
    noDrawings: 'Inga ritningar i projektet.',
    otherOrg: 'Ärenden och ritningar visas för projekt i den organisation du arbetar i.'
  },
  drawings: {
    name: 'Namn',
    project: 'Projekt',
    noProject: 'Inget projekt',
    newDrawing: 'Lägg till ritning',
    saved: 'Ritningen har sparats',
    readFailed: 'Kunde inte läsa ritningen.',
    saveFailed: 'Kunde inte spara ritningen.',
    file: 'Fil',
    position: 'Position (klicka på kartan)',
    saving: 'Sparar…',
    title: 'Ritningar',
    pages: 'Sidor',
    pinnedPhotos: 'Bilder med nål',
    empty: 'Inga ritningar än.'
  },
  viewer: {
    loading: 'Laddar…',
    notFound: 'Ritningen finns inte.',
    updateFailed: 'Kunde inte uppdatera ritningen.',
    deleted: 'Ritningen har tagits bort',
    deleteFailed: 'Kunde inte ta bort ritningen.',
    pageOf: 'Sida {{page}} av {{total}}',
    previous: 'Föregående',
    next: 'Nästa',
    rename: 'Byt namn',
    move: 'Flytta',
    downloadPdf: 'Ladda ner PDF',
    downloadReport: 'Ladda ner rapport',
    reportFailed: 'Kunde inte skapa rapporten.',
    reportTooManyPins: 'Ritningen har fler än 200 nålar.',
    pageAlt: '{{name}}, sida {{page}}',
    photosOnPage: 'Bilder på den här sidan ({{number}})',
    renameTitle: 'Byt namn på ritningen',
    moveTitle: 'Flytta ritningen',
    deleteTitle: 'Ta bort ritningen',
    deleteBody: 'Ritningen tas bort. Dess bilder finns kvar men förlorar sin plats på ritningen.',
    deleteConfirm: 'Ta bort ritningen',
    pinsFromMobile: 'Inga bilder på den här sidan än. Nålar sätts i mobilappen med "Ta bild här".'
  }
};
